import { render } from "./KeluargaTable.vue?vue&type=template&id=0684d420"
import script from "./KeluargaTable.vue?vue&type=script&lang=js"
export * from "./KeluargaTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__